import Config from "../../../../../shared/src/ranj/app/config/Config";

export default class GameConfig extends Config {

    constructor() {
        super();
    }

    get puzzles() {
        return this.getValue(`puzzles`);
    }

    get puzzleCount() {
        return this.puzzles.length;
    }

    getPuzzle(idx) {
        return this.puzzles[idx];
    }

    get time() {
        return this.getValue(`time`);
    }

    getBoxSkin(capacity) {
        return this.getValue(`skins.boxes.${capacity}`);
    }

    getItemSkin(index) {
        return this.getValue(`skins.items`)[index];
    }

}